import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TutorialPage } from './tutorial.page';
import { PagesModule } from '../pages.module';

const routes: Routes = [
  {
    path: '',
    component: TutorialPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [TutorialPage]
})
export class TutorialPageModule { }
